import { render } from "./InventoryNoticeModal.vue?vue&type=template&id=8cbf70f6&scoped=true"
import script from "./InventoryNoticeModal.vue?vue&type=script&lang=js"
export * from "./InventoryNoticeModal.vue?vue&type=script&lang=js"

import "./InventoryNoticeModal.vue?vue&type=style&index=0&id=8cbf70f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbf70f6"]])

export default __exports__